import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: ":formId/:mode",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "administrator-tooling" */ "./ContractTrackForm"
          ),
          import(
            /* webpackChunkName: "administrator-tooling" */ "./modules/ContractTrackFormModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "contractTrackingForm",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
